export function FigmaIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M0.5 12.5C0.5 5.8726 5.8726 0.5 12.5 0.5C19.1274 0.5 24.5 5.8726 24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.8726 24.5 0.5 19.1274 0.5 12.5Z"
        fill="#333333"
      />
      <path
        d="M10.1002 19.7C11.4257 19.7 12.5002 18.6255 12.5002 17.3V14.9H10.1002C8.77471 14.9 7.7002 15.9745 7.7002 17.3C7.7002 18.6255 8.77471 19.7 10.1002 19.7Z"
        fill="#0ACF83"
      />
      <path
        d="M7.7002 12.5001C7.7002 11.1746 8.77471 10.1001 10.1002 10.1001H12.5002V14.9001H10.1002C8.77471 14.9001 7.7002 13.8256 7.7002 12.5001Z"
        fill="#A259FF"
      />
      <path
        d="M7.7002 7.70005C7.7002 6.37456 8.77471 5.30005 10.1002 5.30005H12.5002V10.1H10.1002C8.77471 10.1 7.7002 9.02553 7.7002 7.70005Z"
        fill="#F24E1E"
      />
      <path
        d="M12.5 5.30005H14.9C16.2255 5.30005 17.3 6.37456 17.3 7.70005C17.3 9.02553 16.2255 10.1 14.9 10.1H12.5V5.30005Z"
        fill="#FF7262"
      />
      <path
        d="M17.3 12.5001C17.3 13.8256 16.2255 14.9001 14.9 14.9001C13.5745 14.9001 12.5 13.8256 12.5 12.5001C12.5 11.1746 13.5745 10.1001 14.9 10.1001C16.2255 10.1001 17.3 11.1746 17.3 12.5001Z"
        fill="#1ABCFE"
      />
    </svg>
  );
}
